<button
  mat-mini-fab
  color="primary"
  aria-label=""
  [disabled]="true"
  [ngClass]="className"
>
<!-- (click)="onClickButton($event)" -->

  <mat-icon *ngIf="iconType === 'icon'">{{icon }}</mat-icon>
  <!-- TODO change this to generic svg component -->
  <mat-icon *ngIf="iconType === 'help'" matTooltip="help"  svgIcon="help" class="icon"  ></mat-icon>
</button>
